import actions from './actions'

const initState = {
  tokopediaPolicyDetails: {},
  tokopediaPolicyDetailsMessage: '',
  postTokopediaEndorseMessage: ''
}

export default function appReducer (state = initState, action) {
  switch (action.type) {
    case actions.GET_TOKOPEDIA_POLICY_DETAILS_SUCCESS:
    case actions.GET_TOKOPEDIA_POLICY_DETAILS_FAILURE:
      return {
        ...state,
        tokopediaPolicyDetails: action.data,
        tokopediaPolicyDetailsMessage: action.message
      }
    case actions.GET_FIRSTMEDIA_POLICY_DETAILS_SUCCESS:
    case actions.GET_FIRSTMEDIA_POLICY_DETAILS_FAILURE:
      return {
        ...state,
        tokopediaPolicyDetails: action.data,
        tokopediaPolicyDetailsMessage: action.message
      }
    case actions.POST_TOKOPEDIA_ENDORSE_SUCCESS:
    case actions.POST_TOKOPEDIA_ENDORSE_FAILURE:
      return {
        ...state,
        postTokopediaEndorseMessage: action.message,
        postTokopediaEndorseData: action.data
      }
    case actions.RESET_TOKOPEDIA_ENDORSE_REDUX:
      const { payload } = action
      if (payload && Array.isArray(payload)) {
        let stateToBeReset = {}
        payload.forEach(key => {
          stateToBeReset[key] = initState[key]
        })
        return {
          ...state,
          ...stateToBeReset
        }
      } else {
        return {
          ...state
        }
      }
    default:
      return state
  }
}
